import { merge as objectMapper } from 'object-mapper';

import dayjs, { DATE_FORMAT } from 'utils/dayjs';

import type { GetCollectionOrdersFindByUuidOrExternalReferenceParams } from 'api';

export const apiParams = function (
  params: any
): GetCollectionOrdersFindByUuidOrExternalReferenceParams {
  const map = {
    unique_identifier: 'search_reference',
    start_date: [
      {
        key: 'start_date',
        default: dayjs('1900-01-01').format(DATE_FORMAT)
      }
    ],
    end_date: [
      {
        key: 'end_date',
        default: dayjs().add(1, 'days').endOf('day').format(DATE_FORMAT)
      }
    ]
  };

  return objectMapper(
    params,
    map
  ) as GetCollectionOrdersFindByUuidOrExternalReferenceParams;
};
